import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class Footer extends Component {
    render() {
        return (
            <footer className="footer-five">
                <div className="footer-top">
                    <div className="container">
                        <div className="row footer_sidebar">
                            <div className="widget footer-widget col-xs-6 col-sm-6 col-md-3 wow fadeIn widget1 about_us_widget"> 
                                <Link to='/'>
                                    <span className="logo">
                                        <img src={require('../../images/logo.png')} alt="AppArt"/>
                                    </span>
                                </Link>
                                <p>Selective Gas Installations offer professional services with our domestic and commercial installations.</p>
                            </div>
                            <div className="widget footer-widget col-xs-6 col-sm-6 col-md-3 wow fadeIn widget4 widget_social">
                                <h4 className="widget_title_two">Social Link</h4>
                                <ul className="social-icon">
                                    <li><a href="https://www.facebook.com/Selective-Gas-Installations-860937683989723/?__tn__=%2Cd%2CP-R&eid=ARAE3EXaFtVDzVdR4ZC_p3Bw8JNOlRo_smp2re6Z3_JYLOiZP9EhIEBaLxR8vbA_kGpWbHN0RAaZtXGd"><i className="fa fa-facebook"></i>Facebook</a></li>
                                    <li><a href="https://www.linkedin.com/in/selectivegas/"><i className="fa fa-linkedin"></i> Linkedin </a></li>
                                </ul>
                            </div>
                            <div className="widget footer-widget col-xs-6 col-sm-6 col-md-3 wow fadeIn widget_nav_menu" data-wow-delay="0ms" data-wow-duration="1500ms" data-wow-offset="0">
                                <h4 className="widget_title_two">Quick Links</h4>
                                <div className="menu-quick-links-container">
                                    <ul id="menu-quick-links" className="menu">
                                        <li id="menu-item-844" className="menu-item"><a href="#home">Home</a></li>
                                        <li id="menu-item-845" className="menu-item"><a href="#ourwork">Our Work</a></li>
                                        <li id="menu-item-846" className="menu-item"><a href="#faq">FAQ</a></li>
                                        <li id="menu-item-847" className="menu-item"><a href="#pricing">Get A Quote</a></li>
                                        <li id="menu-item-848" className="menu-item"><a href="#download">Find Us</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="widget footer-widget col-xs-6 col-sm-6 col-md-3 wow fadeIn widget2 widget_contact">
                                <h4 className="widget_title_two">Contact Info</h4>
                                <div className="widget_inner row m0">
                                    <ul>
                                        <li><i className="ti-location-pin"></i>
                                            <div className="location_address fleft">Krugersdorp, Gauteng</div>
                                        </li>
                                        <li><i className="ti-mobile"></i>
                                            <div className="fleft contact_no">+27 83 632 8273</div>
                                        </li>
                                        <li><i className="ti-email"></i>
                                            <div className="fleft contact_mail"><a href="selectivegas@vodamail.co.za"> selectivegas@vodamail.co.za </a></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m0 footer_bottom text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <p>2020 <a href=".">Selective Gas Installations</a>. All rights reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;